import assign from 'lodash.assign';

const { createHigherOrderComponent } = wp.compose;
const { Fragment } = wp.element;
const { InspectorControls } = wp.editor;
const { PanelBody, SelectControl, TextControl, Flex, FlexBlock } = wp.components;
const { addFilter } = wp.hooks;
const { __ } = wp.i18n;
// Enable spacing control on the following blocks
const enablePositionBlocks = [
    'core/column',
    'core/columns',
    'core/group',
    'core/heading',
    'core/paragraph',
    'core/image'

];

const positionControlOptions = [
    {
        label: __('Defatul'),
        value: '',
    },
    {
        label: __('Relative'),
        value: 'sp-position-relative',
    },
    {
        label: __('Sticky'),
        value: 'sp-position-sticky',
    },
    {
        label: __('Absolute'),
        value: 'sp-position-absolute',
    }
];


const blockPositionAttributes = (settings, name) => {
    // Do nothing if it's another block than our defined ones.
    if (!enablePositionBlocks.includes(name)) {
        return settings;
    }

    // Use Lodash's assign to gracefully handle if attributes are undefined
    settings.attributes = assign(settings.attributes, {

        position: {
            type: 'string',
            default: "relative"
        },
        zIndex: {
            type: "string",
            default: ''
        },
        positionLeft: {
            type: "string",
            default: ''
        },
        positionTop: {
            type: "string",
            default: ''
        },
        positionRight: {
            type: "string",
            default: ''
        },
        positionBottom: {
            type: "string",
            default: ''
        }
    });

    return settings;
};

addFilter('blocks.registerBlockType', 'extend-block-example/couter/data', blockPositionAttributes);


/**
 * Create HOC to add spacing control to inspector controls of block.
 */
const withPositionControl = createHigherOrderComponent((BlockEdit) => {
    return (props) => {
        const { setAttributes, position, zIndex } = props;

        // Do nothing if it's another block than our defined ones.
        if (!enablePositionBlocks.includes(props.name)) {
            return (
                <BlockEdit { ...props } />
            );
        }

        const replaceClassName = (find, replace) => {

            var classes = props.attributes.className


            if (classes && classes.includes(find)) {
                const cls = classes.split(' ')
                cls.forEach(function (item, index, arr) {

                    if (item.includes(find)) {
                        arr[ index ] = replace;
                    }

                });
                setAttributes({ className: cls.join(' ') });
            } else {
                if (props.attributes.className) {
                    setAttributes({ className: props.attributes.className + " " + replace });
                } else {
                    setAttributes({ className: replace });
                }
            }
        }

        const setPosition = (val) => {
            setAttributes({ position: val });

            if (val) {
                replaceClassName("sp-position-", val);
            } else {
                replaceClassName("sp-position-", "");
            }
        }
        const setAdditionalClass = (val) => {
            if (val) {
                replaceClassName("sp-zindex-", "sp-zindex-" + val);
            } else {
                replaceClassName("sp-zindex-", "");
            }

        }
        const setPositionClass = (position, val) => {
            if (val) {
                replaceClassName("spposition-" + position, "spposition-" + position + "-" + val);
            } else {
                replaceClassName("spposition-" + position, '');
            }
        }

        return (
            <Fragment>
                <BlockEdit { ...props } />
                <InspectorControls>
                    <PanelBody
                        title={ __('Position') }
                        initialOpen={ false }
                    >


                        <Fragment>
                            <Flex>
                                <FlexBlock>
                                    <SelectControl
                                        label={ __('Postion') }
                                        value={ props.attributes.position }
                                        options={ positionControlOptions }
                                        onChange={ (val) => {
                                            setPosition(val);
                                        } }
                                    />
                                </FlexBlock>
                                <FlexBlock>
                                    <TextControl
                                        type="number"
                                        label={ __("zIndex", 'theme-blocks') }
                                        min={ -10 }
                                        max={ 999 }
                                        step={ 1 }
                                        placeholder="zIndex"
                                        value={ props.attributes.zIndex }
                                        onChange={ (val) => { setAttributes({ zIndex: val }); setAdditionalClass(val); } }
                                    />
                                </FlexBlock>
                            </Flex>
                            { props.attributes.position == 'sp-position-absolute' &&
                                <Flex>
                                    <FlexBlock>
                                        <TextControl
                                            type="number"
                                            label={ __("Left", 'theme-blocks') }
                                            min={ -999 }
                                            max={ 99 }
                                            step={ 1 }
                                            placeholder=""
                                            value={ props.attributes.positionLeft }
                                            onChange={ (val) => { setAttributes({ positionLeft: val }); setPositionClass('left', val); } }
                                        />
                                    </FlexBlock>

                                    <FlexBlock>
                                        <TextControl
                                            type="number"
                                            label={ __("Top", 'theme-blocks') }
                                            min={ -999 }
                                            max={ 1200 }
                                            step={ 1 }
                                            placeholder=""
                                            value={ props.attributes.positionTop }
                                            onChange={ (val) => { setAttributes({ positionTop: val }); setPositionClass('top', val); } }
                                        />
                                    </FlexBlock>

                                    <FlexBlock>
                                        <TextControl
                                            type="number"
                                            label={ __("Right", 'theme-blocks') }
                                            min={ -999 }
                                            max={ 1200 }
                                            step={ 1 }
                                            placeholder=""
                                            value={ props.attributes.positionRight }
                                            onChange={ (val) => { setAttributes({ positionRight: val }); setPositionClass('right', val); } }
                                        />
                                    </FlexBlock>

                                    <FlexBlock>
                                        <TextControl
                                            type="number"
                                            label={ __("Bottom", 'theme-blocks') }
                                            min={ -999 }
                                            max={ 1200 }
                                            step={ 1 }
                                            placeholder=""
                                            value={ props.attributes.positionBottom }
                                            onChange={ (val) => { setAttributes({ positionBottom: val }); setPositionClass('bottom', val); } }
                                        />
                                    </FlexBlock>

                                </Flex>
                            }


                        </Fragment>


                    </PanelBody>
                </InspectorControls>
            </Fragment>
        );
    };
}, 'withPositionControl');

addFilter('editor.BlockEdit', 'extend-block-example/with-position-control', withPositionControl);